/* Koreachi | cart-drawer.js — AJAX slide-out cart */
(function () {
  'use strict';

  var ICON = {
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5h2l2.2 11.2a1 1 0 0 0 1 .8h8.4a1 1 0 0 0 1-.8L21 8H7"/><circle cx="10" cy="20" r="1.2"/><circle cx="18" cy="20" r="1.2"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8.5 12 2.5 2.5 4.5-5"/></svg>'
  };

  /* ---- Shopify-style money formatter ---- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '${{amount}}';
    function num(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var n = (cents / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    switch ((format.match(placeholder) || [])[1]) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      default: value = num(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.threshold = parseInt(this.dataset.threshold, 10) || 0;
      this.shippingNote = this.dataset.shippingNote || '';
      this.body = this.querySelector('[data-cart-body]');
      this.footer = this.querySelector('[data-cart-footer]');
      this.lastFocus = null;
    }

    connectedCallback() {
      var self = this;
      this.querySelectorAll('[data-cart-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.hasAttribute('open')) self.close();
      });
      // Open triggers anywhere on the page
      document.querySelectorAll('[data-cart-open]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });
      // Upsell + item events (delegated)
      this.addEventListener('click', function (e) {
        var up = e.target.closest('[data-upsell-add]');
        if (up) { self.addItem(up.dataset.variantId, 1); return; }
        var rm = e.target.closest('[data-remove]');
        if (rm) { self.changeLine(self.keyOf(rm), 0); return; }
        var dn = e.target.closest('[data-qty-down]');
        if (dn) { self.step(dn, -1); return; }
        var upq = e.target.closest('[data-qty-up]');
        if (upq) { self.step(upq, 1); return; }
      });
      this.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty-input]');
        if (input) self.changeLine(self.keyOf(input), parseInt(input.value, 10) || 0);
      });
    }

    keyOf(el) {
      var item = el.closest('[data-cart-item]');
      return item ? item.dataset.key : null;
    }
    step(btn, dir) {
      var item = btn.closest('[data-cart-item]');
      var input = item.querySelector('[data-qty-input]');
      var q = (parseInt(input.value, 10) || 0) + dir;
      if (q < 0) q = 0;
      this.changeLine(item.dataset.key, q);
    }

    open() {
      this.lastFocus = document.activeElement;
      this.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      var c = this.querySelector('.cart-drawer__close');
      if (c) c.focus();
      this.refresh();
    }
    close() {
      this.removeAttribute('open');
      document.documentElement.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    }

    setLoading(on) { this.body.classList.toggle('cart-loading', !!on); }

    refresh() {
      var self = this;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); });
    }

    addItem(variantId, qty, sellingPlan) {
      var self = this;
      var body = { id: variantId, quantity: qty || 1 };
      if (sellingPlan) body.selling_plan = sellingPlan;
      this.setLoading(true);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          self.open();
          self.setLoading(false);
        });
    }

    changeLine(key, qty) {
      if (!key) return;
      var self = this;
      this.setLoading(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); self.setLoading(false); });
    }

    render(cart) {
      var self = this;
      var money = function (c) { return formatMoney(c, self.moneyFormat); };

      // Header count
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });

      if (cart.item_count === 0) {
        this.body.innerHTML =
          '<div class="cart-drawer__empty">' + ICON.cart +
          '<p>Your cart is empty</p></div>';
        if (this.footer) this.footer.hidden = true;
        return;
      }
      if (this.footer) this.footer.hidden = false;

      var html = '';
      if (this.threshold > 0) {
        var remaining = this.threshold - cart.total_price;
        var pct = Math.min(100, (cart.total_price * 100) / this.threshold);
        html += '<div class="cart-progress"><p class="cart-progress__text">' +
          (remaining > 0
            ? 'You are ' + money(remaining) + ' away from free US shipping'
            : 'You have unlocked free US shipping') +
          '</p><div class="cart-progress__track"><div class="cart-progress__bar" style="width:' + pct + '%"></div></div></div>';
      } else if (this.shippingNote) {
        html += '<p class="cart-shipping-note">' + ICON.check + ' ' + esc(this.shippingNote) + '</p>';
      }

      html += '<div data-cart-items>';
      cart.items.forEach(function (item) {
        var meta = item.selling_plan_allocation
          ? item.selling_plan_allocation.selling_plan.name
          : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
        html +=
          '<div class="cart-item" data-cart-item data-key="' + esc(item.key) + '">' +
            '<div class="cart-item__img">' +
              (item.image ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_128x$1') + '" alt="' + esc(item.product_title) + '" width="64" height="64" loading="lazy">' : '') +
            '</div>' +
            '<div class="cart-item__info">' +
              '<p class="cart-item__title">' + esc(item.product_title) + '</p>' +
              (meta ? '<p class="cart-item__meta">' + esc(meta) + '</p>' : '') +
              '<div class="qty" data-qty>' +
                '<button type="button" data-qty-down aria-label="Decrease quantity">' + ICON.minus + '</button>' +
                '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-input aria-label="Quantity">' +
                '<button type="button" data-qty-up aria-label="Increase quantity">' + ICON.plus + '</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-remove>Remove</button>' +
            '</div>' +
            '<div class="cart-item__price">' + money(item.final_line_price) + '</div>' +
          '</div>';
      });
      html += '</div>';

      this.body.innerHTML = html;

      var sub = this.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  // Expose a small API for product-form.js
  window.Koreachi = window.Koreachi || {};
  window.Koreachi.formatMoney = formatMoney;
  window.Koreachi.cart = {
    el: function () { return document.querySelector('cart-drawer'); },
    open: function () { var d = this.el(); if (d) d.open(); },
    add: function (id, qty, plan) { var d = this.el(); return d ? d.addItem(id, qty, plan) : Promise.resolve(); }
  };
})();
